// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"EmptyState_emptyState__32H6X","title":"EmptyState_title__D2EGj","subtitle":"EmptyState_subtitle__3l3i7","wrapperText":"EmptyState_wrapperText__1mlN4"};